import React from 'react';
import { useDispatch } from "react-redux";
import Note from "../../../../components/Popup/PopupOpInfo/_component/Note";
import { IOperation, IOperation2 } from "../../../../util/varibles/interface";
import { opDetailActions } from "../../reducer";

interface IProps {
    note: string
    data: IOperation2
    isOwn: boolean
}

const ViewNote: React.FC<IProps> = ({ data, note, isOwn }) => {
    const dispatch = useDispatch();

    const handleUpdate = (note: string) => {
        dispatch(opDetailActions.updateOp([{ ...data, operation: { ...data.operation, note } }] as IOperation[]))
    }

    if ((note || '').trim().length === 0)
        return null;

    return <div>
        <Note {...{ operation_code: data.operation.operation_code, note, isEdit: isOwn, handleUpdate }} />
    </div>;
};

export default ViewNote;